import React from 'react';
import MUIDataTable from "mui-datatables";
import DataChip from './chip/DataChip';
import TagModal from './modal/TagModal';
import TriggerModal from './modal/TriggerModal';
import VariableModal from './modal/VariableModal';

export default class VariableDataView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalData: '',
      modalType: ''
    };
    this.chipClick = this.chipClick.bind(this);
    this.modalClose = this.modalClose.bind(this);
  }

  chipClick(data, type) {
    let modalData = {};
    if(typeof window.__GTM_DOCS__.container[type] !== 'undefined'){
      window.__GTM_DOCS__.container[type].forEach((tag)=>{
        if(tag.name === data.name){
          modalData = tag;
        }
      });
    }
    window.dataLayer.push({'event':'chipClick','docTab':'Variable View','chipType':type})

    this.setState({
      modal: true,
      modalData: modalData,
      modalType: type
    });
  };

  modalClose(){
    this.setState({
      modal: false
    })
  }

  render() {
    // const allTags = ['leave-message', 'frequently-busy', 'nice', 'grumpy', 'in-person', 'preferred', 'second-choice'];
    const columns = [
      {
        name: "Variable Name",
        options: {
          filter: true,
          customBodyRenderLite: (dataIndex) => {
              let value = data[dataIndex][0];
              return <DataChip value={value} chipClick={this.chipClick} tagType="variable"/>
              //return <Chip size="small" onClick={()=>this.chipClick(value.name)} variant="outlined" icon={<CodeIcon />} label={value.name} />;

          },
        }
      },
      {
        name: 'Tags',
        options: {
            filter: true,
            filterType: 'multiselect',
            customBodyRenderLite: (dataIndex) => {
                let value = data[dataIndex][1];
                return value.map( (val, key) => {
                  return <DataChip key={key} value={val} chipClick={this.chipClick} tagType="tag"/>
                  //return <Chip size="small" onClick={()=>this.chipClick(val.name)} variant="outlined" icon={<CodeIcon />} label={val.name} key={key} />;
                });
            },
        }
      },
      {
        name: 'Triggers',
        options: {
            filter: true,
            filterType: 'multiselect',
            customBodyRenderLite: (dataIndex) => {
                let value = data[dataIndex][2];
                return value.map( (val, key) => {
                  return <DataChip key={key} value={val} chipClick={this.chipClick} tagType="trigger"/>
                  //return <Chip size="small" onClick={()=>this.chipClick(val.name)}  variant="outlined" icon={<CodeIcon />} label={val.name} key={key} />;
                });
            },
        }
      },
      {
        name: "Variable in Variable References",
        options: {
          filter: true,
          customBodyRenderLite: (dataIndex) => {
              let value = data[dataIndex][3];
              return value.map( (val, key) =>{
                return <DataChip key={key} value={val} chipClick={this.chipClick} tagType="variable"/>
              })
              //return <Chip size="small" onClick={()=>this.chipClick(value.name)} variant="outlined" icon={<CodeIcon />} label={value.name} />;

          },
        }
      },
      {
        name: "Variable Within Parms",
        options: {
          filter: true,
          customBodyRenderLite: (dataIndex) => {
              let value = data[dataIndex][4];
              if(value !== null){
                return value.map( (val, key) =>{
                  return <DataChip key={key} value={val} chipClick={this.chipClick} tagType="variable"/>
                })
              }else{
                return null
              }

              //return <Chip size="small" onClick={()=>this.chipClick(value.name)} variant="outlined" icon={<CodeIcon />} label={value.name} />;

          },
        }
      },
      {
        name: 'Notes',
        options: {
          filter: true
        }
      },
      {
        name: 'Folder',
        options: {
          filter: true
        }
      },
    ];

    const data = window.__GTM_DOCS__.variableData;

    const options = {
      filter: true,
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      elevation: 1,
      onDownload: (buildHead, buildBody, columns, data) => {
        window.dataLayer.push({'event':'docDownload','docTab':'Variable View'})
        //console.log('download');
        console.log(data);
        let downloadData = data.map( (val, key) => {
          let mainVar = val.data[0].name;
          let tag = val.data[1].map(temp=>temp.name||"").toString();
          let trigger = val.data[2].map(temp=>temp.name||"").toString();
          let varInVar = val.data[3].map(temp=>temp.name||"").toString();
          let varWithinParam = (val.data[4] !== null?val.data[4].map(temp=>temp.name||"").toString():"");
          let notes = val.data[5]||"";
          let folder = val.data[6];

          return {index:key, data:[mainVar, tag, trigger, varInVar, varWithinParam, notes, folder]};
        });
        //console.log(downloadData)
          return buildHead(columns) + buildBody(downloadData);
      }
    };

    let modal;
    if (this.state.modal && this.state.modalType === 'tag'){
        modal = <TagModal data={this.state.modalData} type={this.state.modalType} chipClick={this.chipClick} modalState={this.state.modal} modalClose={this.modalClose}/>;
    }
    if (this.state.modal && this.state.modalType === 'trigger'){
        modal = <TriggerModal data={this.state.modalData} type={this.state.modalType} chipClick={this.chipClick} modalState={this.state.modal} modalClose={this.modalClose}/>;
    }
    if (this.state.modal && this.state.modalType === 'variable'){
        modal = <VariableModal data={this.state.modalData} type={this.state.modalType} chipClick={this.chipClick} modalState={this.state.modal} modalClose={this.modalClose}/>;
    }

    return (
      <div>
        {modal}
        <MUIDataTable title={"Google Tag Manager - Variable List ("+data.length+")"} data={data} columns={columns} options={options} />
      </div>
    );

  }
}
